// ## target =>id => "map"
// ## width =>宽度 => 1000
// ## height =>高度 => 700
import getImage from "../gql/getImage.gql";
import imagecosmetology from "../gql/imagecosmetology.gql";
import _ from "lodash";
import moment from 'moment';
import deleteImg from '../assets/delete2.png'
let time = null;
let time2 = null;
export const konvaDraw = {
    data(){
        return {
            KonvaStage:"",
            KonvaData:{},
            layer:"",
            layerSign:"",
            layerButton:"",
            buttonFeature1:"",
            buttonFeature2:"",
            signDetails:false,
            x2:0,
            y2:0,
            x1:0,
            y1:0,
            isDeleteStatus:false,
            isDragStatus:false,
            isRectStatus:false,
            isArrowStatus:false,
            isCircleStatus:false,
            isLineStatus:false,
            isTextStatus:false,
            toggleStatus:false,
            toggleStatusSign:false,
            signText:"显示",
            signId:-1,
            clickDeleteSign:"",
            drwaText:"显示",
            // 标记点的第几个
            signNum:1,
            widthRadio:1,
            heightRadio:1,
            // 储存点击的是哪个编辑模式按钮对象
            editMode: {},
            // 储存移动图片模式按钮对象
            moveImage: {},
            // 储存剪切图片模式按钮对象
            cutImage: {},
            sign_no:"",
            detail_title:"",
           // 添加治疗模板的弹窗状态
            a: {
              status:false,
              sign_no:"",
              signId:"",
              imageId:'',
              signDetailRefresh:false,
              detail_title:""
            }
        }
    },
    mounted() {
      if(this.info){
        this.a.imageId = this.info.id;
      }
    },
    watch:{
      toggleStatusSign(val){
        if(val){
          this.signText = '隐藏'
        }else{
          this.signText = '显示'
          this.signDetails = false;
          this.a.signId = -1;
        }
      },
      toggleStatus(val){
        if(val){
          this.drwaText = '隐藏'
        }else{
          this.drwaText = '显示'
        }
      }
    },
    methods: {
        async setKonva(target,width,height){
            // 设置svg
            this.KonvaStage = new Konva.Stage({
                container : target,    // container 用来容纳舞台的容器
                width : width,
                height : height
            });
            this.layer = new Konva.Layer();  // 创建一个层
            this.layerSign = new Konva.Layer();  // 创建一个层
            let drawData = await this.getImageAnnotation();
            this.KonvaStage.add(this.layer); // 把层添加到舞台
            this.layerButton = new Konva.Layer();  // 创建一个层
            this.KonvaStage.add(this.layerButton); // 把层添加到舞台
            this.KonvaStage.add(this.layerSign); // 把层添加到舞台
            if(!_.isEmpty(drawData)){
                this.widthRadio = width/drawData.width;
                this.heightRadio = height/drawData.height;
                // if((this.widthRadio).toFixed(3)!==(this.heightRadio).toFixed(3)){
                //     this.$message.error("当前非等比缩放状态，标注可能会出现偏差");
                // }
                let drawData1 = drawData.children;
                let drawData2 = drawData.childrenSign;
                drawData1.map(e=>{
                    this.filterType(e.className,e.attrs)
                });
                drawData2.map(e=>{
                  this.filterType(e.className,e.attrs)
                  let newObj = {};
                  newObj.x = e.attrs.x;
                  newObj.y = e.attrs.y;
                  newObj.sqlId = e.attrs.sqlId;
                  newObj.sign_no = e.attrs.sign_no;
                  newObj.detail_title = e.attrs.detail_title;
                  this.drawSign(false,newObj);
              });
            }
            if(this.info.tplType=='hairdressing'){
         
              this.toggleSign();
            }
        },
        async getImageAnnotation(){
            try {
              let mutations;
              let variabless;
              if(this.info.tplType=='hairdressing'){
                mutations = imagecosmetology;
                variabless =  {
                        ids:[this.info.id],
                    }
              }else{
    
                mutations = getImage;
                variabless={
                    id:this.info.id?this.info.id:"",
                }
              }
                let res = await this.$apollo.query({
                    query: mutations,
                    variables:variabless,
                    fetchPolicy: "no-cache"
                });
                let drawData;
                if(this.info.tplType=='hairdressing'){
                  if (!res.data.imagecosmetology) {
                    return null;
                  }
                   drawData = JSON.parse(res.data.imagecosmetology[0].annotation);
                }else{
                  if (!res.data.image) {
                    return null;
                  }
                   drawData = JSON.parse(res.data.image.annotation);
                }
                if(_.isEmpty(drawData)){
                    return null;
                }else{
                    let drawData1 = drawData.children;
                   
                    let newData = {
                        children:[],
                        childrenSign:[],
                        width:drawData.width,
                        height:drawData.height,
                    };
                    for(let i=0;i<drawData1.length;i++){
                        newData.children[i]=JSON.parse(drawData1[i]);
                    }
                    if(drawData.childrenSign){ // 兼容旧版本没有childrenSign字段
                      let drawData2 = drawData.childrenSign;
                      for(let i=0;i<drawData2.length;i++){
                          newData.childrenSign[i]=JSON.parse(drawData2[i]);
                      }
                    }
                    return newData;

                }
            } catch (error) {
                this.$message.error(error.message.split(":")[1]);
                return null;
            }
        },
        // // 获取标注信息
        // getKonvaData(){
        //     return this.layer;
        // },
        filterType(typeName,svgData){
            switch (typeName) {
                case "Circle":this.drawCircle(false,svgData);
                    break;
                case "Arrow":this.drawArrow(false,svgData);
                    break;
                case "Line":this.drawLine(false,svgData);
                    break;
                case "Text":this.drawText(false,svgData);
                    break;
                case "Rect":this.drawRect(false,svgData);
                    break;
            }
        },
        toggleSign(){
          this.restart();
          if(this.toggleStatusSign){
            this.toggleNoKnova();
            this.toggleKonvaSign(false);
          }else{
            this.toggleKonva(false);
            this.toggleKonvaSign(true);
          }
        },
        toggleOther(){
          this.restart();
          if(this.toggleStatus){
            this.toggleNoKnova();
            this.toggleKonva(false);
          }else{
            this.toggleKonva(true);
            this.toggleKonvaSign(false);
          }
        },
        toggleKonvaSign(status){
          if(status){
            this.toggleStatusSign = true;
            this.layerSign.show();
            this.isDragStatus = false;
          }else{
            this.toggleStatusSign = false;
            this.layerSign.hide();
            this.isDragStatus = true;
          }
        },
        toggleNoKnova(){
          this.restart(); // 重置
          if (this.editMode.classList) {
            this.editMode.classList.remove('active');
          }
          if (this.cutImage.classList) {
            this.cutImage.classList.remove('active');
          }
          if (this.moveImage.classList) {
            this.moveImage.classList.add('active');
          }
          this.moveHandler();
        },
        // 切换标注
         toggleKonva(status){
            if(!status){ // 关闭
              if (this.editMode.classList) {
                this.editMode.classList.remove('active');
              }
                this.toggleMap(false);
                this.layer.hide()
                this.isDragStatus = true;
            }else{
                this.toggleMap(true);
                this.layer.show()
                this.isDragStatus = false;
            }
        },
        toggleMap(status){
            this.toggleStatus = status;
            if(!status){
              this.toggleStatusSign = false;
            }
        },
        // 画圆
        drawCircle(status,data){
            // 勾股定理
            // ## var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2))
            let circle ;
            if(status){
                 circle = new Konva.Circle({
                    x:this.x1,      //矩形相对父容器的坐标
                    y:this.y1,
                    radius: Math.sqrt(Math.pow(this.x2-this.x1, 2) + Math.pow(this.y2-this.y1, 2))*0.5,
                    draggable: true,
                    stroke: this.$store.state.clolrPickerDefault,
                    strokeWidth: 5,
                  });
            }else{
                circle = new Konva.Circle({
                    x:data.x*this.widthRadio,      //矩形相对父容器的坐标
                    y:data.y*this.widthRadio,
                    radius: data.radius*this.widthRadio,
                    draggable: true,
                    stroke: data.stroke,
                    strokeWidth: 5,
                  });
            }
            this.KonvaMethod(circle);
        },
        // 画矩形
        drawRect(status,data){
            //绘制外部矩形
            let outRect;
            if(status){
                outRect = new Konva.Rect({
                    x:this.x1,      //矩形相对父容器的坐标
                    y:this.y1,
                    width: Math.abs(this.x2-this.x1),   //矩形的宽高
                    height:Math.abs(this.y2-this.y1),
                    draggable: true,
                    strokeWidth:2,    //描边的宽度
                    stroke:this.$store.state.clolrPickerDefault,     //描边的颜色
                    cornerRadius: 4      //圆角
                });
            }else{
                outRect = new Konva.Rect({
                    x:data.x*this.widthRadio,      //矩形相对父容器的坐标
                    y:data.y*this.widthRadio,
                    width: data.width*this.widthRadio,   //矩形的宽高
                    height:data.height*this.widthRadio,
                    draggable: true,
                    strokeWidth:2,    //描边的宽度
                    stroke:data.stroke,     //描边的颜色
                    cornerRadius: 4      //圆角
                });
            }
            this.KonvaMethod(outRect);
        },
        // 画直线
        drawLine(status,data){
            let line;
            if(status){
                line = new Konva.Line({
                   points: [this.x1,this.y1,this.x2,this.y2],
                   stroke: this.$store.state.clolrPickerDefault,
                   tension: 1,
                   strokeWidth: 4,
                   draggable: true,
                   pointerLength : 10,
                   pointerWidth : 12
                 });
            }else{
                line = new Konva.Line({
                    points: data.points.map(e=>{
                        return e*this.widthRadio
                    }),
                    stroke: data.stroke,
                    tension: 1,
                    strokeWidth: 4,
                    draggable: true,
                    pointerLength : 10,
                    pointerWidth : 12
                  });
            }
            this.KonvaMethod(line);

        },
        // 标文字
        drawText(status,data){
            if(status){

                this.$prompt('请输入您要标注的文本', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                  }).then(({ value }) => {
                    let tip = new Konva.Text({
                        x: this.x1,
                        y: this.y1,
                        text: value,
                        fontSize: 30,
                        draggable: true,
                        fontFamily: 'Calibri',
                        fill: this.$store.state.clolrPickerDefault
                      });
                    this.KonvaMethod(tip);
                  });
            }else{
                let tip = new Konva.Text({
                    x: data.x*this.widthRadio,
                    y: data.y*this.widthRadio,
                    text: data.text,
                    fontSize: 30,
                    draggable: true,
                    fontFamily: 'Calibri',
                    fill: data.fill
                  });
                this.KonvaMethod(tip);
                
            }
        },
        // 画箭头
        drawArrow(status,data){
            let arrow;
            if(status){
                arrow = new Konva.Arrow({
                    points: [this.x1,this.y1,this.x2,this.y2],
                    stroke: this.$store.state.clolrPickerDefault,
                    strokeWidth: 4,
                    tension: 1,
                    draggable: true,
                    pointerLength : 10,
                    pointerWidth : 12
                  });
            }else{

              arrow = new Konva.Arrow({
                points: data.points.map(e=>{
                    return e*this.widthRadio
                }),
                stroke: data.stroke,
                strokeWidth: 4,
                tension: 1,
                draggable: true,
                pointerLength : 10,
                pointerWidth : 12
              });
            }
              this.KonvaMethod(arrow);
            

        },
        // 点击添加标注点
        drawSign(status,data){
          let simpleLabel ;
          if(status){
            simpleLabel = new Konva.Label({
              x: this.x1-20,
              y: this.y1-20,
              sqlId:'',
              detail_title:"",
              sign_no:`${this.signNum}-${this.createOrderNum()}`
            });
      
            simpleLabel.add(
              new Konva.Tag({
                x:this.x1-20,      //矩形相对父容器的坐标
                y:this.y1-20,
                Width: 50,
                Height: 50,
                fill: 'red',
                // shadowBlur: 10,
                cornerRadius: 10,
              })
            );
            this.signNum++;
            simpleLabel.add(
              new Konva.Text({
                text: '',
                fontFamily: 'Calibri',
                fontSize: 18,
                padding: 10,
                lineHeight: 1.2,
                fill: 'white'
              })
            );
            // 直接弹窗
          // this.isDragStatus = true;
          this.a.status=true;
          this.a.signId = simpleLabel.attrs.sqlId;
          this.a.sign_no = simpleLabel.attrs.sign_no;
          this.a.detail_title = simpleLabel.attrs.detail_title;
        }else{
            simpleLabel = new Konva.Label({
              x:data.x*this.widthRadio-20,      //矩形相对父容器的坐标
              y:data.y*this.widthRadio-20,
              sqlId:data.sqlId,
              sign_no:data.sign_no,
              detail_title:data.detail_title
            });
            simpleLabel.add(
              new Konva.Tag({
                x:data.x*this.widthRadio-20,      //矩形相对父容器的坐标
                y:data.y*this.widthRadio-20,
                Width: 50,
                Height: 50,
                fill: 'red',
                // shadowBlur: 10,
                cornerRadius: 10,
              })
            );
            simpleLabel.add(
              new Konva.Text({
                text: data.detail_title,
                fontFamily: 'Calibri',
                fontSize: 18,
                padding: 10,
                lineHeight: 1.2,
                fill: 'white'
              })
            );
        }
        this.KonvaSignMethod(simpleLabel);
        },
         // 点击添加标注点
         drawSignText(data){
          let simpleLabel ;
         
            simpleLabel = new Konva.Label({
              x:data.x,      //矩形相对父容器的坐标
              y:data.y,
              sqlId:data.sqlId,
              sign_no:data.sign_no,
              detail_title:data.detail_title
            });
            simpleLabel.add(
              new Konva.Tag({
                x:data.x,      //矩形相对父容器的坐标
                y:data.y,
                Width: 50,
                Height: 50,
                fill: 'red',
                // shadowBlur: 10,
                cornerRadius: 10,
              })
            );
            simpleLabel.add(
              new Konva.Text({
                text: data.detail_title,
                fontFamily: 'Calibri',
                fontSize: 18,
                padding: 10,
                lineHeight: 1.2,
                fill: 'white'
              })
            );
        this.KonvaSignMethod(simpleLabel);
        },
        drawSignBig(data){
          this.buttonFeature1 = '';
          this.buttonFeature2 = '';
          if(true){
              this.buttonFeature1 = new Konva.Rect({
                  x:data.x,      //矩形相对父容器的坐标
                  y:data.y,
                  width: 80,
                  // draggable: true,
                  height: 43,
                  fill: '#cfc9c9',
                  // shadowBlur: 10,
                  cornerRadius: 10,
              });
                let imageObj = new Image();
              imageObj.onload = ()=> {
                this.buttonFeature2 = new Konva.Image({
                  x: data.x+46,
                  y: data.y+10,
                  image: imageObj,
                  width: 24,
                  height: 24
                });
                this.deleteSign(this.buttonFeature2);
                this.layerButton.add(this.buttonFeature2);
                this.layerButton.batchDraw();
              };
              imageObj.src = deleteImg;
             
          }

          this.KonvaSignMethodButton(this.buttonFeature1);
        },
        KonvaSignMethodButton(name){
          this.deleteSign(name);
           this.layerButton.add(name);
           this.layerButton.draw();
         },
        deleteSign(target){
          target.on('click',async () => {
            clearTimeout(time2);
            this.$confirm('删除标记点, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(async() => {
              if(this.clickDeleteSign.attrs.detail_title ==this.detail_title){
                this.signDetails = false;
                this.sign_no = '';
                this.signId=-1;
                this.detail_title=''
              }
              this.deleteSignAndButton();
              await this.saveKonva();
            }).catch(() => {
               this.clickDeleteSign = '';
                this.buttonFeature1.remove()
                this.buttonFeature2.remove()
                this.layerButton.draw();
            });
            // console.log(this.clickDeleteSign.attrs.sqlId)
            // console.log(this.signId)
            // console.log(this.sign_no)
            // console.log(this.clickDeleteSign.attrs.sign_no)
            // if(this.clickDeleteSign.attrs.detail_title ==this.detail_title){
            //   this.signDetails = false;
            //   this.sign_no = '';
            //   this.signId=-1;
            //   this.detail_title=''
            // }
            // this.deleteSignAndButton();
            // await this.saveKonva();
            

          });
         },
         deleteSignAndButton(){
          this.buttonFeature1.remove()
              this.buttonFeature2.remove()
              this.layerButton.draw();
              this.clickDeleteSign.remove();
              this.layerSign.draw();
         },
        KonvaSignMethod(name){
         this.click(name);
         this.dbclickEdit(name);
         if(!this.info.tplType2){
          this.dragSign(name)
        }
          this.layerSign.add(name);
          this.layerSign.draw();
          
        },
        KonvaMethod(name){ // 画完图形后的事件
            this.dbclickDeleteSelf(name);
            this.drag(name);
            this.layer.add(name);    //把绘制的图形添加到图层上
            this.layer.draw();
        },
        // 双击删除自己
        dbclickDeleteSelf(target){
            target.on('dblclick',() => {
                target.destroy();
                this.layer.draw();
              });
        },
        // 拖动 //微信是hover在边框时，更换鼠标形状，可拖动
        drag(target){
            target.on('mouseover', () => {
                document.body.style.cursor = 'move';
                this.isDrag();
            });
            target.on('mouseout', () => {
            document.body.style.cursor = 'default';
                this.isDragStatus = false;
            });
            target.on('dragstart', ()=> {
                this.isDrag();
                // get index
                // let index = target.zIndex();

                // set index
                target.moveToTop();
              });
              target.on('dragend', ()=> {
                this.isDragStatus = false;
              });
        },
         // 拖动 //微信是hover在边框时，更换鼠标形状，可拖动
         dragSign(target){
           let hasDelete = false;
  
          target.on('mouseover', () => {
              document.body.style.cursor = 'default';
              this.isDrag();
              hasDelete = false;
              if(  this.buttonFeature1){
              this.clickDeleteSign = '';
                this.buttonFeature1.remove()
                this.buttonFeature2.remove()
                this.layerButton.draw();
              }
              clearTimeout(time2);
              if(!hasDelete){
              this.clickDeleteSign = target;
                this.drawSignBig(target.attrs);
                hasDelete = true;
              }
          });
          target.on('mouseout', () => {
          document.body.style.cursor = 'default';
              this.isDragStatus = false;
              
              clearTimeout(time);
              clearTimeout(time2);
              // 执行延时
              time2 = setTimeout(() => {
                hasDelete = false;
              this.clickDeleteSign = '';

                this.buttonFeature1.remove()
                this.buttonFeature2.remove()
                this.layerButton.draw();
              }, 1000);

          });
          target.on('mouseup', ()=> {
            this.isDrag();
          });
          target.on('mousedown', ()=> {
            this.isDragStatus = false;
          });
      },
      async updateSignId(value){
        let isupdate = false;
        let item = this.layerSign.children
        item.map(e => {
          if(e.attrs.sign_no === this.a.sign_no){
            e.attrs.sqlId = value.sqlId;
            e.attrs.detail_title = value.detail_title;
            this.signId = value.sqlId;
            this.detail_title = value.detail_title;
            e.children[1].attrs.text=value.detail_title;
            // 移除没有文字的标点
            e.remove();
            // 重新绘制新的标点，将数据复制过去
            this.drawSignText(e.attrs);
            this.layerSign.draw();
            isupdate = true;
          }

        });
        if(isupdate){

          await this.saveKonva();
        }
      },
        click(target){
          target.on('click',() => {
             // 取消上次延时未执行的方法
             clearTimeout(time);
             // 执行延时
             time = setTimeout(() => {
              this.isDragStatus = true;
              this.signDetails = false;
              this.signDetails = true;
              this.a.signId = target.attrs.sqlId;
              this.sign_no = target.attrs.sign_no;
              this.detail_title = target.attrs.detail_title;
              if(target.attrs.sqlId){
                this.signId = target.attrs.sqlId;
              }else{
                this.signId = -1;
              }
              this.a.sign_no = target.attrs.sign_no;
              this.a.detail_title = target.attrs.detail_title;
             }, 300);
           
          });
        },
        setsign_no(val){
          this.sign_no = val
        },
        setTitle_detail(val){
          this.detail_title = val
        },
        dbclickEdit(target){
          target.on('dblclick',() => {
            clearTimeout(time);
            if(!this.info.tplType2){
              this.isDragStatus = true;
              this.a.status=true;
              this.a.signId = target.attrs.sqlId;
              this.a.sign_no = target.attrs.sign_no;
              this.a.detail_title = target.attrs.detail_title;
            }
          });
        },
        createOrderNum(){
          let newNum = moment().format("YYYY-MM-DD-HH:mm:ss");
          return newNum;
        },
        addSign(e){
          var e = event || window.event;
          //获取偏移量
          this.x1=e.offsetX;
          this.y1=e.offsetY;
          // console.log('dbl00')
          if(!this.isDragStatus){
            // console.log('dbl11')
            if(this.toggleStatusSign){
              // console.log('dbl22')
              // console.log(this.commonData)
              // console.log(this.info)
              if(!this.info.tplType2){
                // console.log('dbl33')
                this.drawSign(true)
              }
        }}
        },
        // 鼠标按下
        mousedown(e) {
            var e = event || window.event;
            //获取偏移量
            this.x1=e.offsetX;
            this.y1=e.offsetY;
        },
        // 鼠标松开
        mouseup(e) {
            var e = event || window.event;
            this.x2=e.offsetX;
            this.y2=e.offsetY;
            this.switchDraw();
        },
        dblclick(){
            // this.KonvaData.remove();
        },
        isRect(event){
            if (this.editMode.classList) {
              this.editMode.classList.remove('active');
            }
            if (this.cutImage.classList) {
              this.cutImage.classList.remove('active');
            }
            if (this.moveImage.classList) {
              this.moveImage.classList.remove('active');
            }
            event.srcElement.classList.add('active');
            this.editMode = event.srcElement;
            this.toggleKonva(true);
            this.toggleKonvaSign(false);
          this.clearAllStatus();
            this.isRectStatus = true;
            this.restart(); // 重置
            this.toggleMap(true);
        },
        isDrag(){
            this.isDragStatus = true;
        },
        isDelete(){
            this.clearAllStatus();
            this.isDeleteStatus = true;
        },
        isArrow(event){
            if (this.editMode.classList) {
              this.editMode.classList.remove('active');
            }
            if (this.cutImage.classList) {
              this.cutImage.classList.remove('active');
            }
            if (this.moveImage.classList) {
              this.moveImage.classList.remove('active');
            }
            event.srcElement.classList.add('active');
            this.editMode = event.srcElement;
            this.toggleKonva(true);
            this.toggleKonvaSign(false);
          this.clearAllStatus();
            this.isArrowStatus = true;
            this.restart(); // 重置
            this.toggleMap(true);
        },
        isCircle(event){
            if (this.editMode.classList) {
              this.editMode.classList.remove('active');
            }
            if (this.cutImage.classList) {
              this.cutImage.classList.remove('active');
            }
            if (this.moveImage.classList) {
              this.moveImage.classList.remove('active');
            }
            event.srcElement.classList.add('active');
            this.editMode = event.srcElement;
            this.toggleKonva(true);
            this.toggleKonvaSign(false);
            this.clearAllStatus();
            this.isCircleStatus = true;
            this.restart(); // 重置
            this.toggleMap(true);
        },
        isLine(event){
          if (this.editMode.classList) {
            this.editMode.classList.remove('active');
          }
          if (this.cutImage.classList) {
            this.cutImage.classList.remove('active');
          }
          if (this.moveImage.classList) {
            this.moveImage.classList.remove('active');
          }
          event.srcElement.classList.add('active');
          this.editMode = event.srcElement;
          this.toggleKonva(true);
            this.toggleKonvaSign(false);
          this.clearAllStatus();
            this.isLineStatus = true;
            this.restart(); // 重置
            this.toggleMap(true);
        },
        isText(event){
            if (this.editMode.classList) {
              this.editMode.classList.remove('active');
            }
            if (this.cutImage.classList) {
              this.cutImage.classList.remove('active');
            }
            if (this.moveImage.classList) {
              this.moveImage.classList.remove('active');
            }
            event.srcElement.classList.add('active');
            this.editMode = event.srcElement;
            this.toggleKonva(true);
            this.toggleKonvaSign(false);
          this.clearAllStatus();
            this.isTextStatus = true;
            this.restart(); // 重置
            this.toggleMap(true);
        },
        clearAllStatus(){
            this.isRectStatus = false;
            this.isDragStatus = false;
            this.isDeleteStatus = false;
            this.isArrowStatus = false;
            this.isCircleStatus = false;
            this.isLineStatus = false;
            this.isTextStatus = false;
        },
        switchDraw(){
            if(!this.isDragStatus){
                if(this.isRectStatus){
                    this.drawRect(true);
                }else if(this.isArrowStatus){
                    this.drawArrow(true);
                }else if(this.isCircleStatus){
                    this.drawCircle(true);
                }else if(this.isLineStatus){
                    this.drawLine(true);
                }else if(this.isTextStatus){
                  // console.log(666)
                  if(!this.toggleStatusSign){
                    this.drawText(true);
                  }
                }
            }
        }


    },
}
